// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"292050b8","453":"1c0542e2","615":"3440b33a","804":"b43c8fe8","875":"f21f9dec","996":"eda41810"}[chunkId] + ".chunk.js";
};